module.exports = __webpack_public_path__ + "static/img/アセット 48@3x.a1ea023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 48@3x.png
// module id = mEdA
// module chunks = 1